<script setup>
import FsLightbox from "fslightbox-vue/v3";
import { ref } from "vue";
const toggler = ref(false);
const sources = ref([]);

defineProps({
    photos: Object
});

const openLightbox = (image) => {
    sources.value = [image];
    toggler.value = !toggler.value;
};
</script>
<template>
  <section class="text-gray-600 body-font">
    <div class="container 2xl:px-24 xl:px-0 xl:pb-14 pb-4 mx-auto">

      <div class="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 2xl:gap-8 lg:gap-6 gap-4 mb-2 cursor-pointer">
          <div class="group overflow-hidden relative w-full 2xl:h-[580px] xl:h-[550px] lg:h-[430px] h-full border" @click="openLightbox(photo.image)" v-for="photo in photos" :key="photo.id">
            <VLazyImage :src="photo?.image" :alt="photo?.title" class="w-full h-full object-cover" />
              <div
                  class="absolute inset-0 bg-black bg-opacity-40 text-center top-0 left-0 gap-2 opacity-0 group-hover:opacity-100 transition duration-300 h-full w-full">

                    <div class="absolute top-[45%] xl:left-[48%] lg:left-[44%] left-[40%] text-center mx-auto">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="1.5" stroke="currentColor" class="w-9 h-9 text-white">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" />
                        </svg>
                            </div>
                        </div>

          </div>
    </div>

    <FsLightbox :toggler="toggler" :sources="sources" />
  </div>
</section></template>
<style scoped></style>
